// Pedido confirmado: senha, cashback ganho, contagem pra voltar (verbatim).
// No BALCÃO (30/09/2026) o caixa não espera a contagem: Enter começa a próxima
// venda na hora, e um bip do leitor também — o item bipado já entra no
// carrinho novo (hooks/useLeitorBalcao).
import { Check, Coins } from "lucide-react";

import { CartaoNoAcompanhamento } from "../../cartao-fidelidade";
import { fmtBRL } from "../cashback";
import TeclaAtalho from "../components/TeclaAtalho";
import { useAtalhosBalcao } from "../hooks/useAtalhosBalcao";

export default function TelaConfirmacao({ ctx }) {
  const { telaCls, orderCode, countdown, resetTotem, customerName, ganhoConfirmado, autoAtendimento, pedidoConfirmadoId } = ctx;
  useAtalhosBalcao({ Enter: () => { resetTotem(); return true; } }, !autoAtendimento);
  return (
    <div className={`${telaCls} bg-zinc-950 flex flex-col items-center justify-center select-none overflow-hidden`}>
      {/* Celebration background */}
      <style>{`
        @keyframes confetti-fall {
          0% { transform: translateY(-50px) rotate(0deg) scale(0); opacity: 0; }
          15% { opacity: 1; transform: translateY(0) rotate(30deg) scale(1); }
          85% { opacity: 0.8; }
          100% { transform: translateY(calc(100vh + 50px)) rotate(720deg) scale(0.6); opacity: 0; }
        }
        @keyframes check-pop {
          0% { transform: scale(0) rotate(-45deg); opacity: 0; }
          60% { transform: scale(1.2) rotate(5deg); opacity: 1; }
          100% { transform: scale(1) rotate(0deg); opacity: 1; }
        }
        @keyframes senha-pop {
          0% { transform: scale(0.5); opacity: 0; }
          70% { transform: scale(1.08); }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
      {/* Glow orbs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[15%] w-[40vw] h-[40vw] rounded-full bg-green-500/8 blur-3xl animate-pulse" style={{ animationDuration: '3s' }} />
        <div className="absolute bottom-[-10%] right-[10%] w-[45vw] h-[45vw] rounded-full bg-orange-500/6 blur-3xl animate-pulse" style={{ animationDuration: '4s', animationDelay: '1s' }} />
      </div>
      {/* Content */}
      <div className="text-center space-y-6 px-8 relative z-10">
        <div className="w-28 h-28 rounded-full bg-green-500/20 flex items-center justify-center mx-auto border-2 border-green-500/30" style={{ animation: 'check-pop 0.6s ease-out forwards' }}><Check className="w-16 h-16 text-green-500" /></div>
        <h1 className="text-4xl md:text-5xl font-black text-zinc-100">Pedido Confirmado!</h1>
        {/* Sem senha (desligada em Preferências para o módulo): nada no lugar. */}
        {orderCode && (
          <div className="space-y-2" style={{ animation: 'senha-pop 0.5s ease-out 0.3s both' }}>
            <p className="text-lg text-zinc-400">Sua senha:</p>
            <p className="text-7xl md:text-9xl font-black text-primary" data-e2e="senha-pedido">{orderCode}</p>
          </div>
        )}
        {customerName && <p className="text-xl text-zinc-300">{customerName.trim()}</p>}
        {ganhoConfirmado > 0 && <p className="text-lg font-semibold text-emerald-300 flex items-center justify-center gap-2" data-e2e="confirmacao-cashback"><Coins className="w-5 h-5" /> +{fmtBRL(ganhoConfirmado)} de cashback na sua carteira quando o pedido for concluído</p>}
        {pedidoConfirmadoId && <div className="max-w-md mx-auto w-full"><CartaoNoAcompanhamento pedidoId={pedidoConfirmadoId} darkMode /></div>}
        <p className="text-lg text-zinc-400">Aguarde ser chamado</p>
        <p className="text-sm text-zinc-500">Voltando ao início em {countdown}s</p>
        <button onClick={resetTotem} data-e2e="confirmacao-novo-pedido" className="mt-4 px-8 py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 rounded-xl transition-colors inline-flex items-center gap-2">Novo Pedido{!autoAtendimento && <TeclaAtalho>Enter</TeclaAtalho>}</button>
      </div>
    </div>
  );
}
